export { MultiInputEmail } from './MultiInputEmail';
export type { MultiInputEmailProps } from './MultiInputEmail';

